const locationManager = {
    debug: true,
    init: async function () {

        if ( this.debug ) {
            console.log("Location Manager - Version 1.0.0");
        }

        const geocodeData = window.locationData;

        const locationSelect = this.loadSelectedLocationFromLocal();

        if (locationSelect && locationSelect != "undefined") {
            //if location is in local storage, set text content of header location dropdown
            if ( this.debug ) {
                console.log("Found a location in local storage:", locationSelect);
            }
            
            this.setDropdownContent(locationSelect);
            this.storePage();
            this.selectThisStore(locationSelect);
        } else {
            const userLocation = await this.locateUser();

            if ( this.debug ) {
                console.log("User Location:", userLocation);
            }

            if (userLocation && userLocation.location.latitude && userLocation.location.longitude) {
                //if location is not in local storage, find closest location based on user location
                if ( this.debug ) {
                    console.log("Finding closest location based on user location");
                }
                const closestLocation = this.findClosestLocation(geocodeData, userLocation);
                this.setDropdownContent(closestLocation);
                this.storePage();
                this.selectThisStore(closestLocation);

            } else {
                //if no user location, use the first location from geocodeData
                if ( this.debug ) {
                    console.log("No user location found, using first location from geocodeData");
                }
                const firstLocation = Object.keys(geocodeData)[0];
                this.setDropdownContent(firstLocation);
                this.storePage();
                this.selectThisStore(firstLocation);
            }
        }
    },
    locateUser: async function () {
        try {
            const located = await fetch("https://api.ipapi.is")
            const result = await located.json();
            if (!result || !result.location.latitude || !result.location.longitude) {
                return {}
            } 
            
            return result;
            
        } catch (error) {
            console.error("Error locating user:", error);
        }
    },
    findClosestLocation: function ( geocodeData , userLocation ) {
        let closestDistance = 0;
        let closestLocation
        let count = 0;

            //check lat,long from result with locations data to find the closest one to customer
        for (const [key, value] of Object.entries(window.locationData)) {
            const geocode = value;
            const handle = key;

            if ( this.debug ) {
                console.log("GEO LAT", parseFloat(geocode.latitude), "GEO LONG", geocode.longitude, "RES LAT", userLocation.latitude, "RES LONG", userLocation.longitude )
            }

            const geoLat = parseFloat(geocode.latitude)
            const geoLong = parseFloat(geocode.longitude)

            const distance = this.haversine(geoLat, geoLong, userLocation.latitude, userLocation.longitude)

            if (count == 0) {
                closestDistance = distance
                closestLocation = handle
            } else {
                if ( distance < closestDistance ) {
                    closestDistance = distance
                    closestLocation = handle
                }
            }
            count++

            if ( this.debug ) {
                console.log('LOCATION: ', geocode.location_name, "DISTANCE: ", distance)
                console.log(' FOUND ', closestLocation )
            }

        }

        this.setLocationPageSelectedStore(closestLocation)
        if ( this.debug ) {
            console.log("closest location", closestLocation, "closest distance", closestDistance)
        }
        return closestLocation;

    },
    haversine: function(lat1, lon1, lat2, lon2) {
        const R = 6371; // Radius of the earth in km
        const dLat = this.deg2rad(lat2 - lat1);
        const dLon = this.deg2rad(lon2 - lon1); 
        const a = 
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * 
            Math.sin(dLon / 2) * Math.sin(dLon / 2); 
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)); 
        const d = R * c; // Distance in km
        return d;
    },
    deg2rad: function(deg) {
        return deg * (Math.PI / 180)
    },
    setLocationPageSelectedStore: function(location) {
        localStorage.setItem("store_location", location); 
    },
    loadSelectedLocationFromLocal: function() {
        return localStorage.getItem("store_location");
    },
    extractHoursText: function (hoursData) {
        let hoursHtml = ""

        if (hoursData && hoursData.children) {
            hoursData.children.forEach(paragraph => {
                if (paragraph.type === "paragraph" && paragraph.children) {
                    paragraph.children.forEach(textNode => {
                        if (textNode.type === "text" && textNode.value) {
                            if (textNode.bold) {
                                hoursHtml += `<strong>${textNode.value}</strong><br>`;  
                            } else {
                                hoursHtml += `${textNode.value}<br>`
                            }
                        }
                    })
                }
            })
        }

        return hoursHtml  
    },
    setDropdownContent: function( locationHandle ) {
        const location = window.locationData[locationHandle];
        if ( this.debug ) {
            console.log("Setting dropdown content for location:", location);
        }

        const headerName = document.querySelectorAll(".js-store-name")
        const headerAddress = document.querySelectorAll(".js-store-address")
        const headerHours = document.querySelectorAll(".js-store-hours")
        const headerContact = document.querySelectorAll(".js-store-contact")

       const hoursText = this.extractHoursText(location.hours)  

        for (let i = 0; i < headerName.length; i++) {
            const name = headerName[i]
            name.textContent = location.location_name
        }

        for (let i = 0; i < headerAddress.length; i++) {
            const address = headerAddress[i]
            address.innerHTML = `<a href="${location.google_map_link}" target="_blank">${location.address_1}<br>${location.address_2}</a>`
        }

        for (let i = 0; i < headerHours.length; i++) {
            const hour = headerHours[i]
            hour.innerHTML = hoursText
        }

        for (let i = 0; i < headerContact.length; i++) {
            const contact = headerContact[i]
            contact.innerHTML = `<a href="tel:${location.phone_number}">${location.phone_number}</a>`
        }
    },
    storePage: function() {
        //select this store button click event
        const selectStoreBtns = document.querySelectorAll("button.select-store.btn")
        //console.log("btns", selectStoreBtns)

        if ( selectStoreBtns ) {
            for (let i = 0; i < selectStoreBtns.length; i++) {
                const button = selectStoreBtns[i]
                const locationName = button.dataset.locationName

                button.addEventListener("click", function() {
                    locationManager.setLocationPageSelectedStore(locationName);
                    locationManager.setDropdownContent(locationName);

                    button.classList.add("selected-store")

                    for (let i = 0; i < selectStoreBtns.length; i++) {
                        const btn = selectStoreBtns[i]

                        if (btn.classList.contains("selected-store") && btn != button) {
                            btn.classList.remove("selected-store")
                        }
                    }

                    if (button.dataset.redirectUrl) {
                        requestAnimationFrame(function() {
                            window.location.assign(button.dataset.redirectUrl);
                        });
                    }
                })
            }
        }
    },
    selectThisStore: function(locationName) {
        console.log("Selecting store:", locationName);
        const findButton = document.querySelector('.select-store.btn[data-location-name="' + locationName + '"]');
        if (findButton) {
            findButton.classList.add("selected-store");
        }
    }
}

document.addEventListener("DOMContentLoaded", function() {
    locationManager.init();
})
